import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useNavigate } from "react-router-dom";
import { WORKFLOW_DASHBOARD } from '../../common/URLs';

import { toast } from 'react-toastify';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { Card, CardContent, Typography, Button, Grid } from '@mui/material';
import { SubmitIcon } from '../../common/icons';
import apiClient from '../../axios';


function PitWorkFlow() {
    const navigate = useNavigate();
    const [workflowData, setWorkflowData] = useState();

    const Container = styled('div')(({ theme }) => ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(4),
        padding: theme.spacing(3),
        backgroundColor: '#f5f5f5',
    }));

    const Box = styled(Paper)(({ theme }) => ({
        padding: theme.spacing(3),
        width: 305,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    }));

    const Count = styled(Typography)(({ theme }) => ({
        fontSize: 32,
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    }));

    useEffect(() => {
        getAllWorkflowCount();
    }, []);

    const getAllWorkflowCount = () => {
        loaderService.showLoader();
        apiClient.post(WORKFLOW_DASHBOARD,
            {
                "roleName": localStorage.getItem('role')
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setWorkflowData(response.data?.workflowCountList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const navigateTo = (category) => {

        if (category === "Pending PO") {
            navigate("/poApproval");
        }
        else if (category === "Approved PO") {
            navigate("/poApproval", { state: { tabVal: "1" } });
        }
        else if (category === "Pending STO") {
            navigate("/stoApproval");
        }
        else if (category === "Approved STO") {
            navigate("/stoApproval", { state: { tabVal: "1" } });
        }
        else if (category === "Pending SO") {
            navigate('/servicePOApprovalList');
        }
        else if (category === "Approved SO") {
            navigate('/servicePOApprovalList', { state: { tabVal: "1" } })
        }
        else if (category === "Pending Modified PO") {
            navigate("/poApproval", { state: { tabVal: "2", tabValueModify: "false" } });
        }
        else if (category === "Approved Modified PO") {
            navigate("/poApproval", { state: { tabVal: "2", tabValueModify: "true" } });
        }
        else if (category === "Pending Modified STO") {
            navigate("/stoApproval", { state: { tabVal: "2", tabValueModify: "false" } });
        }
        else if (category === "Approved Modified STO") {
            navigate("/stoApproval", { state: { tabVal: "2", tabValueModify: "true" } });
        }
        else if (category === "Pending Modified SO") {
            navigate("/servicePOApprovalList", { state: { tabVal: "2", tabValueModify: "false" } });
        }
        else if (category === "Approved Modified SO") {
            navigate("/servicePOApprovalList", { state: { tabVal: "2", tabValueModify: "true" } });
        }
        else if (category === "Send Back For PO Modification") {
            navigate('/poList', { state: { tabVal: "2" } })
        }
        else if (category === "Modified PO") {
            navigate('/poList', { state: { tabVal: "3" } })
        }
        else if (category === "Send Back For STO Modification") {
            navigate('/stoList', { state: { tabVal: "2" } })
        }
        else if (category === "Modified STO") {
            navigate('/stoList', { state: { tabVal: "3" } })
        }
        else if (category === "Send Back For SO Modification") {
            navigate('/soList', { state: { tabVal: "2" } })
        }
        else if (category === "Modified SO") {
            navigate('/soList', { state: { tabVal: "3" } })
        }
        else if (category === "Pending LLE Chipping Schedule") {
            navigate('/chippingApproval');
        }
        else if (category === "Approved LLE Chipping Schedule") {
            navigate('/chippingApproval', { state: { tabValue: "Approve" } });
        }
        else if (category === "Pending GRN") {
            navigate('/grnApprove');
        }
        else if (category === "Approved GRN") {
            navigate('/grnApprove', { state: { tabValue: "true" } });
        }
        else if (category === "Pending SES") {
            navigate('/sesApproval');
        }
        else if (category === "Approved SES") {
            navigate('/sesApproval', { state: { tabValue: "true" } });
        }
        else if (category === "Pending RB Schedule") {
            navigate("/rbScheduleApproval");
        }
        else if (category === "Approved RB Schedule") {
            navigate("/rbScheduleApproval", { state: { tabVal: "Approve" } });
        }
        else if (category === "Pending CB Schedule") {
            navigate("/cbScheduleApproval");
        }
        else if (category === "Approved CB Schedule") {
            navigate("/cbScheduleApproval", { state: { tabVal: "Approve" } });
        }
    }



    return (
        <Container>
            <Grid container spacing={2} style={{ padding: 10 }}>
                {/* {workflowData && workflowData?.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card variant="outlined" >
                            <CardContent>
                                <Count variant="h4">{item.count}</Count>
                                <Typography variant="subtitle1" component="h2">
                                    {item.category}
                                </Typography>

                                <Button sx={{
                                    backgroundImage: 'linear-gradient(to right, #02AAB0 0%, #00CDAC 51%, #02AAB0 100%)',
                                    margin: '10px',
                                    padding: '15px 45px',
                                    textAlign: 'center',
                                    textTransform: 'uppercase',
                                    transition: '0.5s',
                                    backgroundSize: '200% auto',
                                    boxShadow: '0 0 20px #eee',
                                    borderRadius: '10px',
                                    display: 'block',
                                    color: 'text.primary', // Uses theme color
                                    textDecoration: 'none',
                                    '&:hover': {
                                        backgroundPosition: 'right center',
                                        color: '#fff',
                                        textDecoration: 'none'
                                    }
                                }}
                                    component={Link}
                                    to={`/${item.link}`}
                                    variant="contained"
                                    color="primary"
                                    style={{ marginTop: 10 }}
                                >
                                    View All
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))} */}
                {workflowData && workflowData?.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box elevation={3}>
                            <Count variant="h4">{item.count}</Count>
                            <Typography variant="subtitle1" color="textSecondary" >
                                {item.category}
                            </Typography>
                            <Button
                                // component={Link}
                                // to={`/${item.link}`}
                                onClick={(e) => navigateTo(item.category)}
                                variant='contained'
                                sx={{ mt: 2,  }}
                                endIcon={<SubmitIcon />}
                            >
                                View all
                            </Button>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Container >
    );
};

export default PitWorkFlow;